import { useCallback } from "react";

import { HttpHeaderNames } from "@touchtech/web-api-client";

import { InstoreHttpHeaderNames, LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";
import { api } from "@is/services/api";

export const useManageApiHeaders = () => {
  const tenantId = LocalStorageService.getItem(LocalStorageKeys.TenantId);
  const storeId = LocalStorageService.getItem(LocalStorageKeys.StoreId);
  const deviceId = LocalStorageService.getItem(LocalStorageKeys.DeviceId);
  const sessionId = LocalStorageService.getItem(LocalStorageKeys.SessionId);
  const locale = LocalStorageService.getItem(LocalStorageKeys.LanguageCode);
  const countryCode = LocalStorageService.getItem(LocalStorageKeys.CountryCode);

  /**
   * Reads storage when it is CALLED, never closing over the render-time values
   * above. `AppRoutes` applies these from a passive effect, and React runs a
   * child's effects before its parent's — so a snapshot taken at the parent's
   * render would overwrite the session `EntryView` had just created with the
   * stale, already-checked-out one, and every basket write would target the
   * locked session (ticket aecd58ce).
   */
  const setApiHeaders = useCallback(() => {
    const currentTenantId = LocalStorageService.getItem(
      LocalStorageKeys.TenantId
    );
    const currentStoreId = LocalStorageService.getItem(
      LocalStorageKeys.StoreId
    );
    const currentDeviceId = LocalStorageService.getItem(
      LocalStorageKeys.DeviceId
    );
    const currentSessionId = LocalStorageService.getItem(
      LocalStorageKeys.SessionId
    );
    const currentLocale = LocalStorageService.getItem(
      LocalStorageKeys.LanguageCode
    );
    const currentCountryCode = LocalStorageService.getItem(
      LocalStorageKeys.CountryCode
    );

    if (currentTenantId) {
      api.setHeader(HttpHeaderNames.TENANT_ID, currentTenantId);
    }

    if (currentStoreId) {
      api.setHeader(InstoreHttpHeaderNames.StoreId, currentStoreId);
    }

    if (currentDeviceId) {
      api.setHeader(InstoreHttpHeaderNames.DeviceId, currentDeviceId);
    }

    if (currentSessionId) {
      api.setHeader(InstoreHttpHeaderNames.SessionId, currentSessionId);
    }

    if (currentLocale) {
      api.setHeader("Accept-Language", currentLocale);
    }

    if (currentCountryCode) {
      api.setHeader("x-delivery-country", currentCountryCode);
    }
  }, []);

  return {
    setApiHeaders,
    tenantId,
    storeId,
    deviceId,
    sessionId,
    locale,
    countryCode,
  };
};
